var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "my-4",
    attrs: {
      "id": "selected-video"
    }
  }, [_c('div', {
    staticClass: "container-fluid m-0 p-0"
  }, [_c('div', {
    staticClass: "row m-0 home-video-container text",
    class: _vm.videoContainer
  }, [_c('div', {
    staticClass: "col-12 p-0 d-flex flex-column"
  }, [_c('EmbeddedVideoPlayer', {
    attrs: {
      "isMP4Video": true,
      "videoId": "HOME_PAGE_VIDEO_001",
      "selectedVideoId": "HOME_PAGE_VIDEO_001",
      "videoSource": "https://projectspectrumlearning.io/tsv/Project%20Spectrum%20Services_WhyDoBusinessWithThe%20DIB.mp4",
      "videoThumbnail": "https://projectspectrumlearning.io/tsv/ProjectSpectrumServices_WhyDoBusinessWithTheDIB_Thumbnail.png"
    }
  }), _c('div', {
    staticClass: "my-3 d-flex flex-column align-items-start justify-content-center flex-lg-row align-items-lg-center justify-content-lg-between flex-xl-row align-items-xl-center justify-content-xl-between"
  }, [_vm._m(0), _c('div', {
    staticClass: "w-auto d-flex flex-row align-items-center svg-images"
  }, [_c('img', {
    attrs: {
      "src": require('@assetsImages/youtube-brands-1.svg'),
      "width": "30px",
      "height": "30px"
    },
    on: {
      "click": _vm.openYoutubeVideo
    }
  }), _c('img', {
    attrs: {
      "src": require('@assetsImages/Share-08.svg'),
      "width": "20px",
      "height": "20px"
    },
    on: {
      "click": _vm.toggleVideoCopy
    }
  }), _vm.isDropdownOpen ? _c('CopyUrlClipboard', {
    attrs: {
      "classes": 'share-button-from-left',
      "urlSource": _vm.homePageVideoUrl,
      "copyHandlerComplete": _vm.toggleVideoCopy
    }
  }) : _vm._e()], 1)])], 1), _vm._m(1)])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-auto"
  }, [_c('p', {
    staticClass: "text-start m-0 title-text"
  }, [_vm._v(" Why Do Business with the DIB ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-auto"
  }, [_c('p', {
    staticClass: "text-start m-0 title-description"
  }, [_vm._v(" Entrepreneurship in the Defense Industrial Base (DIB) empowers small businesses to drive innovation, create jobs, and make a real impact on national defense. This video highlights how small companies, not just major contractors, play a vital role across key sectors like manufacturing, R&D, and knowledge-based services. By wearing multiple hats, these entrepreneurs strengthen the industrial base and reflect the core values of independence and resilience. ")])]);

}]

export { render, staticRenderFns }